import React from "react";
import "../styles/pago.css";

import mercadoPagoLogo from "../images/mercadopago.png";
import transferenciaLogo from "../images/transferencia.png";
import efectivoLogo from "../images/efectivo.png";

import angel1 from "../images/angel3.png";
import angel2 from "../images/angel9.png";

export default function Pago() {
  const telefono = "+54 9 11 5626-9545"; 

  const mensaje = "Hola Vicky, quiero reservar una consulta de Tarot Angélico.";

  const whatsappLink = `https://wa.me/${telefono}?text=${encodeURIComponent(
    mensaje
  )}`;

  return (
    <section className="pago-section">
      <img src={angel1} alt="Ángel decorativo" className="angel-pago angel-pago-1" />
      <img src={angel2} alt="Ángel decorativo" className="angel-pago angel-pago-2" />

      <div className="pago-contenedor">
        <h2 className="pago-titulo">Formas de Pago</h2>

        <p className="pago-subtitulo">
          Elegí la opción que te resulte más cómoda para abonar tu consulta.
        </p>

        <div className="pagos-grid">
          <div className="pago-card">
            <img src={mercadoPagoLogo} alt="Mercado Pago" className="pago-logo" />
            <h3>Mercado Pago</h3>
            <p>Tarjetas de crédito, débito y dinero en cuenta.</p>
          </div>

          <div className="pago-card">
            <img src={transferenciaLogo} alt="Transferencia bancaria" className="pago-logo" />
            <h3>Transferencia Bancaria</h3>
            <p>Solicitá los datos bancarios y enviá tu comprobante por WhatsApp.</p>
          </div>

          <div className="pago-card">
            <img src={efectivoLogo} alt="Efectivo" className="pago-logo" />
            <h3>Efectivo</h3>
            <p>Disponible coordinando previamente la consulta.</p>
          </div>
        </div>

        <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn-reservar">
          ✨ Reservar Consulta ✨
        </a>

        <p className="pago-seguridad">
          🔒 Todos los pagos son tratados de forma segura y confidencial.
        </p>
      </div>
    </section>
  );
}